import PropTypes from 'prop-types';
import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';

import CalendarEventInterestForm from './CalendarEventInterestForm';
import isLockedPresale from '../utils/isLockedPresale';
import { promoCodeMask } from '../../shared/promoCodeValidation';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const canSubmit = (promoCodeName) => Boolean(promoCodeName && promoCodeName.length > 0);

const PresaleUnlockPanel = ({
  confirm,
  csrfToken,
  ticketTypes,
  promoCodeName,
  promoCodeNameChanged,
  promoCodeNameValid,
  lookupPromoCode,
  addOns,
  ticketReservation,
  userContext,
  announceListEnabled,
}) => {
  const [showNotify, setShowNotify] = useState(false);

  const lockedTicketTypes = ticketTypes.filter(isLockedPresale);

  return (
    <>
      <div className="card border-primary" style={{ marginBottom: '15px', background: '#f5f8ff' }}>
        <div className="card-body" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
          <p className="mb-2 text-primary" style={{ fontSize: '13px', fontWeight: 'bold', letterSpacing: '0.04em' }}>
            <span className="mr-2" style={{ color: '#2ecc71' }}>&#9679;</span>
            PRESALE IS LIVE NOW
          </p>
          <p className="mb-3" style={{ fontSize: '18px', fontWeight: 'bold' }}>
            Enter your presale code to unlock tickets
          </p>

          <form onSubmit={(e) => {
            e.preventDefault();
            if (!canSubmit(promoCodeName)) return;
            lookupPromoCode(confirm, promoCodeName, ticketTypes, csrfToken, addOns, ticketReservation, userContext);
          }}>
            {!promoCodeNameValid ? (
              <p className="text-danger small mb-1">Sorry. That code is invalid.</p>
            ) : null}
            <div className="input-group input-group-lg mb-0">
              <MaskedInput
                mask={promoCodeMask()}
                className={'form-control ' + (promoCodeNameValid ? '' : 'text-danger ')}
                guide={false}
                placeholder="Presale code"
                value={promoCodeName || ''}
                onChange={(e) => promoCodeNameChanged(e.target.value.toUpperCase())}
              />
              <div className="input-group-append">
                <button
                  className="btn"
                  type="submit"
                  disabled={!canSubmit(promoCodeName)}
                  style={{ backgroundColor: '#FF595E', color: 'white', border: 'none', fontWeight: 'bold' }}
                >
                  Unlock
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {lockedTicketTypes.length > 0 ? (
        <div className="card border-0" style={{ background: '#f9f9f9', marginBottom: '15px' }}>
          <div className="card-body" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
            {lockedTicketTypes.map((ticketType, index) => (
              <div
                key={ticketType.id}
                className={'d-flex justify-content-between align-items-center py-2' + (index > 0 ? ' border-top' : '')}
              >
                <div>
                  <p className="mb-0" style={{ fontSize: '16px', fontWeight: 'bold' }}>{ticketType.name}</p>
                  <p className="mb-0" style={{ fontSize: '14px', filter: 'blur(4px)', userSelect: 'none' }}>
                    {formatter.format(parseFloat(ticketType.calculated_price))}
                  </p>
                </div>
                <p className="mb-0 text-muted" style={{ fontSize: '14px' }}>
                  <i className="fas fa-lock mr-1"></i>Locked
                </p>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {announceListEnabled ? (
        <div className="mb-3">
          {showNotify ? (
            <>
              {confirm.public_on_sale_time_human ? (
                <p className="mb-2 text-muted" style={{ fontSize: '13px' }}>
                  {`Public on-sale is ${confirm.public_on_sale_time_human}.`}
                </p>
              ) : null}
              <CalendarEventInterestForm confirm={confirm} csrfToken={csrfToken} interestType="Announce" />
            </>
          ) : (
            <a href="#" onClick={(e) => { e.preventDefault(); setShowNotify(true); }}>
              No code? Get notified for the public on-sale
            </a>
          )}
        </div>
      ) : null}
    </>
  );
};

PresaleUnlockPanel.propTypes = {
  confirm: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  ticketTypes: PropTypes.array.isRequired,
  promoCodeName: PropTypes.string,
  promoCodeNameChanged: PropTypes.func.isRequired,
  promoCodeNameValid: PropTypes.bool,
  lookupPromoCode: PropTypes.func.isRequired,
  addOns: PropTypes.array,
  ticketReservation: PropTypes.object,
  userContext: PropTypes.object,
  announceListEnabled: PropTypes.bool,
};

export default PresaleUnlockPanel;
